import { gql, useEnhancedQuery } from "@uplift-ltd/apollo";
import { makeUrl } from "@uplift-ltd/strings";
import React from "react";
import Alert from "components/common/Alert";
import Heading from "components/common/Heading";
import Link from "components/common/Link";
import { INDIVIDUAL_COURSES_CATEGORY_ID } from "constants/site";
import { COURSE_URL } from "constants/urls";
import { mapNodes } from "helpers/mapNodes";
import { IndividualCoursesQueryQuery as IndividualCoursesQuery } from "./__generated__/IndividualCourses";
import styles from "./IndividualCourses.module.css";

const ALERT_MESSAGE =
  "Please note: SOME courses do not fulfill the pre-licensing requirements for ALL licenses.";

const INDIVIDUAL_COURSES_QUERY = gql`
  query IndividualCoursesQuery($categoryId: Int!, $displayInCatalog: Boolean) {
    courses(first: 1000, where: { categoryId: $categoryId, displayInCatalog: $displayInCatalog }) {
      edges {
        node {
          id
          title
          materials
          slug
        }
      }
    }
  }
`;

const IndividualCourses = () => {
  const { data, loading } = useEnhancedQuery<IndividualCoursesQuery>(INDIVIDUAL_COURSES_QUERY, {
    variables: { displayInCatalog: true, categoryId: INDIVIDUAL_COURSES_CATEGORY_ID },
  });

  if (loading) return null;
  if (!data || !data.courses) return null;

  const courses = mapNodes(data.courses);

  return (
    <div className={styles.root}>
      <Heading tag="h3" className={styles.subHeading}>
        Individual Courses Fulfilling CA Pre-License Requirements
      </Heading>
      <Alert theme="info" className="my-4">
        {ALERT_MESSAGE}
      </Alert>
      <div className={styles.individualCoursesList}>
        {courses.map(course => (
          <Link
            key={course.id}
            className={styles.individualCoursesListItem}
            href={makeUrl(COURSE_URL, { slug: course.slug as string, page: "" })}
          >
            {course.title}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default IndividualCourses;
